import { tok } from '@sunwebgroup/ui-components'
import { Tag } from '@sunwebgroup/ui-components/uds'
import { css, RuleSet, styled } from 'styled-components'

export type Collection = 'default'
  | 'boutique'
  | 'cycling'
  | 'excellent'
  | 'famfun'
  | 'primavera'
  | 'secrets'
  | 'selections'
  | 'villages'
  | 'xperience'
  | 'atlantis'
  | 'totally'
  | 'child'
  | 'pearls'
  | 'culinary'
  | 'romantic'
  | 'newest-discoveries'

interface CollectionTagProps extends React.PropsWithChildren {
  collectionName: Collection
}

const StyledTag = styled(Tag)<{ $collectionName: Collection }>`
  ${({ $collectionName }) => modCollection($collectionName)}
`

export function CollectionTag({ children, collectionName }: CollectionTagProps): JSX.Element {
  return <StyledTag $collectionName={collectionName}>{children}</StyledTag>
}

function modCollection(collectionName: Collection): RuleSet<object> {
  return ({
    'default': css`
      background-color: #f5f5f5; 
      color: #333;`,
    'boutique': css`
      background-color: ${tok('primitives_color_collection_boutique')}; 
      color: ${tok('primitives_color_neutral_0')};`,
    'cycling': css`
      background-color: ${tok('primitives_color_collection_cycling')}; 
      color: ${tok('primitives_color_neutral_0')};`,
    'excellent': css`
      background-color: ${tok('primitives_color_collection_excellent')}; 
      color: ${tok('primitives_color_neutral_0')};`,
    'famfun': css`
      background-color: ${tok('primitives_color_collection_famfun')}; 
      color: ${tok('primitives_color_neutral_0')};`,
    'primavera': css`
      background-color: ${tok('primitives_color_collection_primavera')}; 
      color: ${tok('primitives_color_neutral_1000')};`,
    'secrets': css`
      background-color: ${tok('primitives_color_collection_secrets')}; 
      color: ${tok('primitives_color_neutral_1000')};`,
    'selections': css`
      background-color: ${tok('primitives_color_collection_selections')}; 
      color: ${tok('primitives_color_neutral_1000')};`,
    'villages': css`
      background-color: ${tok('primitives_color_collection_villages')}; 
      color: ${tok('primitives_color_neutral_0')};`,
    'xperience': css`
      background-color: ${tok('primitives_color_collection_xperience')}; 
      color: ${tok('primitives_color_neutral_0')};`,
    'atlantis': css`
      background-color: ${tok('primitives_color_collection_atlantis')}; 
      color: ${tok('primitives_color_neutral_1000')};`,
    'totally': css`
      background-color: ${tok('primitives_color_collection_totally')}; 
      color: ${tok('primitives_color_neutral_1000')};`,
    'child': css`
      background-color: ${tok('primitives_color_collection_child')}; 
      color: ${tok('primitives_color_neutral_1000')};`,
    'pearls': css`
      background-color: ${tok('primitives_color_collection_pearls')}; 
      color: ${tok('primitives_color_neutral_0')};`,
    'culinary': css`
      background-color: ${tok('primitives_color_collection_culinary')}; 
      color: ${tok('primitives_color_neutral_1000')};`,
    'romantic': css`
      background-color: ${tok('primitives_color_collection_honeymoon')}; 
      color: ${tok('primitives_color_neutral_0')};`,
    'newest-discoveries': css`
      background-color: ${tok('primitives_color_collection_newest_discoveries')}; 
      color: ${tok('primitives_color_neutral_0')};`,
  })[collectionName]
}
